import React, {useState} from 'react';
import {
  Button,
  Card,
  Classes,
  ControlGroup,
  Elevation,
  InputGroup,
  Intent,
  NonIdealState,
  Toaster
} from "@blueprintjs/core";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {Position} from "monaco-editor";
import qrCode from '../../assets/wx.png';
import styles from './index.module.less';

const toaster = Toaster.create({
  position: Position.TOP,
  usePortal: true
});
const ExchangeCourse = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const handleSubmitCode = () => {
    setLoading(true);
    axios.post('/api/course/active_course', { code }).then((response) => {
      const { code } = response.data;
      setLoading(false);
      if (code !== 0) {
        toaster.show({
          message: '激活码不正确',
          timeout: 3000,
          intent: Intent.DANGER
        });
      } else {
        history.replace('/');
      }
    });
  };
  return (
    <NonIdealState
      title='兑换课程'
      description='请在下方输入框中输入你获取到的兑换码兑换相应的课程'
      icon='exchange'
      action={
        <ControlGroup vertical={false}>
          <InputGroup value={code} onChange={(e) => setCode(e.target.value)} placeholder="请输入兑换码" style={{ width: 250 }} large />
          <Button loading={loading} onClick={handleSubmitCode} intent={Intent.SUCCESS} icon='send-message' large>立即兑换</Button>
        </ControlGroup>
      }
    >
      <p className={Classes.UI_TEXT}>若有任何疑问，请扫描下方二维码联系客服</p>
      <Card className={styles.card} elevation={Elevation.THREE}>
        <img className={styles['qr-code']} src={qrCode} alt=""/>
      </Card>
      <p>若你未购买课程，请点击<a href='//www.pythontip.com/sales'>此链接</a>查看课程详情。</p>
    </NonIdealState>
  );
};

export default ExchangeCourse;
